"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetGuestToken = void 0;
var pow_1 = require("./pow");
function GetGuestToken(params) {
    var url = params.baseUrl;
    if (!url) {
        url = "https://apis.frontdoorhome.com/iam/proof-of-work/v1/api/GUEST";
    }
    fetch(url, {
        method: 'GET',
    }).then(function (resp) {
        return resp.json();
    }).then(function (json) {
        var res = pow_1.RunProofOfWork(json.challenge);
        var body = {
            result: res
        };
        fetch(url + "/" + res.challenge.challenge, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        }).then(function (resp) {
            return resp.json();
        }).then(function (token) {
            params.handler(token.data.token);
        }).catch(function (error) { return params.handler(error); });
    }).catch(function (error) { return params.handler(error); });
}
exports.GetGuestToken = GetGuestToken;
